import React from 'react';
import {graphql} from 'gatsby';
import ListProducts from '../../components/ListProducts';
import SEO from '../../components/Seo';
import BreadCrumb from '../../components/Breadcrumb';

const Categories = ({data, location}) => {
  const {categorie} = data;
  const {title, description} = categorie.frontmatter;
  return (
    <>
      <BreadCrumb
        location={location}
        showProducts={true}
        title={`Les ${title}`}
      />
      <SEO title={`Tous les ${title} de Mercredi Biscuiterie Lyon`} />
      <h1>{`Les ${title.toLowerCase()} de Mercredi Biscuiterie Lyon`}</h1>
      <p>{description}</p>
      <br />
      <ListProducts data={data} />
    </>
  );
};

export default Categories;

export const query = graphql`
  query CategoryQuery($relativePath: String!, $slug: String!) {
    allMdx(
      filter: {
        frontmatter: {active: {ne: false}, categories: {eq: $relativePath}}
        fileAbsolutePath: {regex: "/(/products/)/"}
      }
      sort: {fields: frontmatter___title}
    ) {
      nodes {
        ...ProductList
      }
    }
    categorie: mdx(fields: {slug: {eq: $slug}}) {
      productsCategorie {
        id
      }
      frontmatter {
        title
        description
      }
    }
  }
`;
